export default "__VITE_ASSET__BONsP5CK__"